import React from 'react';

export function PlusIcon() {
	return (
		<svg width="24" height="24" xmlns="http://www.w3.org/2000/svg">
			<g>
				<rect
					id="svg_1"
					height="22"
					width="4"
					y="1"
					x="10"
					strokeWidth="0"
					stroke="#000"
					fill="#0071bc"
				/>
				<rect
					id="svg_3"
					height="4"
					width="22"
					y="10"
					x="1"
					strokeWidth="0"
					stroke="#000"
					fill="#0071bc"
				/>
			</g>
		</svg>
	);
}
